import PromoCard from "../PromoCard/index.tsx";

export default function ImportReportCard({ onClose }: { onClose: () => void }) {
  return (
    <PromoCard
      badge="New"
      title="Manuscript Analysis"
      description="Get a detailed report on POV, tense, and more when you import."
      ctaLabel="Learn More"
      ctaUrl="https://feedback.sudowrite.com/changelog/new-personalized-next-steps-with-import-report"
      onClose={onClose}
    />
  );
}
